<template>
  <div>
    <Nav isActive="Task"/>   
    <div class="pageWD mT20" >
      <div>   
        <el-row :gutter="20">
          <el-col :span="6" >       
            <div class="shadowBox minHeight">
              <div class="mainTop f18 c3" >答题卡<span class="etime">倒计时  {{msg}}</span></div>
                <div class="cardItem">
                  <div class="st flex"><span class="f16 c3 s1">未答</span><span  class="f16 c3 s2">已答</span></div>
                  <div v-if="list_dx.length > 0">   
                    <div class="f16 c9 t">单选题</div>  
                    <div class="flex">                                                    
                      <div class="item" v-for="(item,index) in list_dx" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div> 
                    </div>                      
                  </div>
                  <div v-if="list_dd.length > 0">
                    <div class="f16 c9 t">多选题</div>
                    <div class="flex" >                
                        <div class="item" v-for="(item,index) in list_dd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>
                  <div v-if="list_pd.length > 0">
                    <div class="f16 c9 t">判断题</div>
                    <div class="flex" >                   
                          <div class="item" v-for="(item,index) in list_pd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>
                  <!-- <div v-if="list_tk.length > 0">
                    <div class="f16 c9 t">填空题</div>
                    <div class="flex">                    
                        <div class="item" v-for="(item,index) in list_tk" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div> -->
                  <div v-if="list_jd.length > 0">   
                    <div class="f16 c9 t">简答题</div>
                    <div class="flex" >                                 
                        <div class="item" v-for="(item,index) in list_jd" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div>
                    </div>
                  </div>      
                </div>
            </div>          
            </el-col>
            <el-col :span="18">    
              <div class="shadowBox minHeight" v-if="pageData">
                  <div class="mainTop f18 c3">{{pageData.info.exTitle}}</div>
                  <div class="subItems" v-for="(item,index) in questions" :key="index" :id="'choose'+(index+1)">
                      <div class="subl">
                          <div class="title single">
                              <span class="d">{{item.QT_Index}}.</span>
                              <span class="t" v-if="item.QT_Type=='1'">单选题</span>
                              <span class="t" v-if="item.QT_Type=='2'">多选题</span>
                              <span class="t" v-if="item.QT_Type=='3'">判断题</span>
                              <span class="t" v-if="item.QT_Type=='4'">填空题</span>
                              <span class="t" v-if="item.QT_Type=='5'">简答题</span>
                              <span class="d" v-html="item.QT_Content.replace(/<\/?[^>]*>/g,'')"></span>
                              <span class="s">({{item.Score}}分)</span>
                          </div>
                          <div class="items"  v-if="item.QT_Type=='1'">                         
                              <el-radio-group v-model="item.AN_Content" @change="changeType(item.QT_Index,item.QT_Type)" >
                                <div v-for="(_item,index) in item.items" :key="index" >  
                                  <el-radio :label="index+1">{{_item.siContent}}</el-radio>
                                </div>
                              </el-radio-group>
                          </div>
                          <div class="items"  v-if="item.QT_Type=='2'">
                              <el-checkbox-group v-model="item.AN_Content_Arr" @change="changeType(item.QT_Index,item.QT_Type)" >
                                <div v-for="(_item,index) in item.items" :key="index" >        
                                  <el-checkbox  :label="index+1" >{{_item.siContent}}</el-checkbox>
                                </div>  
                              </el-checkbox-group>                         
                          </div>
                          <div class="items"  v-if="item.QT_Type=='3'">      
                              <el-radio-group v-model="item.AN_Content" @change="changeType(item.QT_Index,item.QT_Type)">                           
                                <div><el-radio label="1">正确</el-radio></div>
                                <div><el-radio label="2">错误</el-radio></div>                            
                            </el-radio-group>                                                                                  
                          </div>  
                          <div class="items"  v-if="item.QT_Type=='5'">
                              <el-input type="textarea" v-model="item.AN_Content" placeholder="请输入答案" :rows="5" @input="changeType(item.QT_Index,item.QT_Type)"></el-input>                 
                          </div>                    
                      </div>                    
                </div>             
              </div>         
          </el-col>
        </el-row>    
    </div> 
   </div>
<div style="height:92px"></div>   
   <div class="cardFotter" >
       <div class="pageWD" style="text-align:right;padding-top:13px">
         <el-button type="primary"  style="width:83px" @click="subForm">提交</el-button>
       </div>
   </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import {getExamInfo, getExamCard, saveAllAnswer } from '@/api/api'
import Nav from "../../components/Nav.vue";
var Letter =["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"]
export default {
  
  components: { Nav}, 
   data() {
      return {
        LeaveIndex :true,
        maxtime:'',
        msg:'',
        Letter:["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"],        
        showtype:false,
        tiId:this.$route.query.taskTI_ID,
        exId:this.$route.query.liId,
        pageData:null,
        percent_:'',
        hg:'',
        zdsc:'',
        list_dx:[],
        list_dd:[],
        list_pd:[],
        list_tk:[],
        list_jd:[],
        questions:[]
      };
    },
    created() {  
      console.log(Cookies.get('LastTime'))    
      this.getExamCardFun()
      this.getExamInfoFun()    
     
    },
    beforeRouteLeave (to, from, next) {
        if(this.LeaveIndex){
          // 这里需要elementui的支持，如果使用其他界面组件自行替换即可
          this.$confirm('正在离开本页面，确认是否离开', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 正常跳转
            next()
          }).catch(() => {
            // 如果取消跳转地址栏会变化，这时保持地址栏不变
            window.history.go(1)
          })
        }else{
          next()
        }
    },
    methods: {  
        goAnchor(selector) {//参数selector是id选择器（#anchor14）
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      changeType(QT_Index,QT_Type){
        var that = this
        if(QT_Type == '1')//单选题
          { 
            this.list_dx.forEach(function(item) { 
              if(item.QT_Index == QT_Index){
                  item.answer='1';
              }
            })
          }
        if(QT_Type == '3')//判断
          {
            this.list_pd.forEach(function(item) { 
              if(item.QT_Index == QT_Index){
                  item.answer='1';
              }
            })
          }
        if(QT_Type == '2')//多选题
          {                  
              this.list_dd.forEach(function(item) { 
                if(item.QT_Index == QT_Index){
                  if(that.questions[QT_Index-1].AN_Content_Arr.length!='0'){
                    item.answer='1';
                  }  else{
                      item.answer='';
                  } 
                }
              })
        }     
        if(QT_Type == '5')//简答
          {                  
              this.list_jd.forEach(function(item) { 
                if(item.QT_Index == QT_Index){
                  if(that.questions[QT_Index-1].AN_Content!=''){
                    item.answer='1';
                  }  else{
                      item.answer='';
                  } 
                }
              })
          }                 
      } ,   
      subForm(){
        var that = this
         this.$confirm('是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
           that.subForms()
          }).catch(() => {
            
          })
      },
      subForms(){
        var that = this
          var contentArr = []
          console.log(this.questions)
          this.questions.forEach(function(item) { 
                if(item.QT_Type =='2'){
                  var AN_Content = item.AN_Content_Arr.toString()
                }else{
                   var AN_Content = item.AN_Content.toString()
                }
                var tempData = 
                {
                  stid:item.QT_ID,
                  content:AN_Content
                }
                contentArr.push(tempData)
          })
          console.log(contentArr)          
          var that = this
          var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId ,
            content:JSON.stringify(contentArr),
              coId: Cookies.get('qslCOID') 
          } 
          saveAllAnswer(data)
          .then(res => {           
            console.log(res)
            that.LeaveIndex = false
            this.$router.go(-1);

          })
          .catch(err => {});
      } ,
      goAnchor(selector) {
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      temp_arr(QT_Answer){
        var QT_Arr = QT_Answer.split('|') 
        var temp_arr = ''
        for(var i=0;i<QT_Arr.length;i++){
            var ii = QT_Arr[i]
            temp_arr+= Letter[ii]
        }
        return(temp_arr)        
      },
      getExamCardFun(){
         var that = this
         var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId      
         } 
          getExamCard(data)
          .then(res => {           
            let listItems = res.body.result
             listItems.forEach(function(item) { 
              
                if(item.QT_Type == '1')
                {                  
                  that.list_dx.push(item)
                }
                if(item.QT_Type == '2')
                {                  
                  that.list_dd.push(item)
                }
                 if(item.QT_Type == '3')
                {                  
                  that.list_pd.push(item)
                }
                 if(item.QT_Type == '4')
                {                  
                  that.list_tk.push(item)
                }
                 if(item.QT_Type == '5')
                {                  
                  that.list_jd.push(item)
                }   
              })           
          })
          .catch(err => {});
      },
      getExamInfoFun(){
         var that = this
         var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId,
            exId:   that.exId  
         } 
          getExamInfo(data)
          .then(res => { 
             console.log(res.body.result)  
             that.pageData = res.body.result
             var data = res
             if(data.code=='200'){
                        if(data.body.result.examStatus=='0'||data.body.result.examStatus=='3'){
                            that.maxtime = data.body.result.info.exExamTime*60
                        }else if(data.body.result.examStatus=='1'){
                            var d1 = Date.parse(new Date());
                            var d2 = data.body.result.examanswer.AN_CreateOn;
                            var zdsc = Math.floor(((d1 - d2)/1000))
                            that.maxtime = data.body.result.info.exExamTime * 60 - zdsc
                        }else if(data.body.result.examStatus=='2'){                   
                             that.subPlease
                        }                        
                        console.log(that.questions)
                        that.questions = data.body.result.questions
                        that.questions.forEach((item, index) => {         
                          this.$set(item, 'AN_Content_Arr',[]);
                        })	
                        timer = setInterval(that.CountDown,1000);  
             }
          })
          .catch(err => {});
      }  ,
       //倒计时
          
      subPlease(){
        var that = this
        this.$alert('答题时间到，请提交试卷！', '提示信息', {
            showClose: false,
            confirmButtonText: '确定提交',    
          })
            .then(() => {
              that.subForms()
          })   
      }  ,
     CountDown(){  
        var that = this
        if(that.maxtime>=0){  
        var minutes = Math.floor(that.maxtime/60);  
        var seconds = Math.floor(that.maxtime%60);  
        that.msg = minutes+"分"+seconds+"秒";  
       
        if(that.maxtime==0){				  
            var flag = false;
             that.subPlease()
        }
            --that.maxtime;  				
        }  
        else{  
        clearInterval(timer); 		
        }  
    } 
      // 倒计时事件
      // countdown() {
      //   const that = this
      //   that._interval = setInterval(() => {
      //     if(that.countTime == 0) {
      //         // 计时结束，清除缓存
      //         clearInterval(that._interval)
      //       } else {
      //         that.countTime--
      //         let day = parseInt(that.countTime / 60 / 60 / 24)
      //         let hr = parseInt(that.countTime / 60 / 60 % 24)
      //         let min = parseInt(that.countTime / 60 % 60)
      //         let sec = parseInt(that.countTime % 60)

      //         day = day > 9 ? day : '0' + day
      //         hr = hr > 9 ? hr : '0' + hr
      //         min = min > 9 ? min : '0' + min
      //         sec = sec > 9 ? sec : '0' + sec
      //         that.toLiveBtn = `${hr}时${min}分${sec}秒`
      //       }
      //   }, 1000);
      // }
    }
  };
</script>
<style scoped>
.subItems{
  padding:24px;
  font-size:14px;
  display:flex;
  padding-bottom:0
}
.subItems .subl{
  width:670px;
  margin-right:60px
}
.subItems .items{
  color:#333333;
  line-height:22px;
}
.subItems .items div{
  margin:10px 0
}
.color_red{
  color:#F7413F
}
.color_blue{
  color:#4B9AFB
}
.subItems .res{
  width: 668px;
  height: 46px;
  line-height:46px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-top:20px
}
.subItems .res2{
  padding:24px;
  background: #f0f0f0;
  line-height:22px;
  color:#ccc
}
>>>.el-textarea__inner
{
  width: 668px;
  height: 184px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding:24px;
  font-size:14px;
}
.subItems .res span{
  padding:0 20px
}
 p{
  display:inline
}
.subItems .subr{
  flex:1;
  font-size:14px;
  color:#333;
  font-weight:bold
}
.subItems .title{
  margin-bottom:14px;
  line-height:24px
}
.subItems .d{
  font-size:14px;
  color:#333;
  font-weight:bold;
}
.subItems .s{
  color:#999;
  font-size:14px;
  margin-left:50px
}
.subItems .t{
  width: 44px;
  height: 19px;
  background: rgba(255,255,255,0.00);
  border: 1px solid #4b9afb;
  border-radius: 2px;
  font-size:12px;
  color:#4B9AFB;
  line-height:21px;
  padding:2px 3px
}
.cardItem{
padding:24px
}
.cardItem .t{
  margin:3px 0 15px 0;
}

.cardItem .item{
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 4px;
  margin-right: 15px;
  margin-bottom:15px;
  font-size:14px;
  color:#333;
  text-align: center;
  line-height: 40px;
   cursor: pointer;
}
.cardItem .select{
  color:#4B9AFB;
  border:1px solid #4B9AFB;
  background: #e4f0fe;
}
.cardItem .flex{ 
  flex-direction: row;
  flex-wrap: wrap;
}
.cardItem .st span{
  position: relative;
  flex:1;
  padding-left:20px;
  padding-bottom:15px
}
.cardItem .st span::before{
  content: '';
  position:absolute;
  left:0px;
  top:6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.cardItem .st .s1::before{ 
  background: #f0f0f0;
}
.cardItem .st .s2::before{ 
  background: #4B9AFB;
}
.cardFotter{
  height: 72px;
  background: #ffffff;
  width:100%;
  position: fixed;
  bottom:0;
  left:0;right: 0;
}

.ksjg{
  background:#F0F0F0;
  margin:24px;
  padding:40px
}
.ksjg .flex{
  margin-bottom:40px ;  
}
.ksjg .flex div{
  flex:1
}
.ckjg{
  text-align:center;
  padding:16px 0 40px 0
}

.el-button{
  font-size:18px;
  padding:14px 20px
}
.etime{
  color:#F7413F;
  font-size:14px;
  margin-left:24px
}
</style>


// WEBPACK FOOTER //
// src/views/Exam/index.vue